"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Storyblok = _interopRequireDefault(require("../../utils/Storyblok"));

var _customProps = require("../../utils/customProps");

var _MuiTableHead = _interopRequireDefault(require("./components/MuiTableHead/MuiTableHead"));

var _MuiTableBody = _interopRequireDefault(require("./components/MuiTableBody/MuiTableBody"));

var MuiTable = function MuiTable(_ref) {
  var rootClass = _ref.rootClass,
      padding = _ref.padding,
      size = _ref.size,
      stickyHeader = _ref.stickyHeader,
      tHead = _ref.tHead,
      tBody = _ref.tBody;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  return /*#__PURE__*/_react.default.createElement(_core.Table, {
    className: styles.root,
    padding: padding,
    size: size,
    stickyHeader: stickyHeader
  }, /*#__PURE__*/_react.default.createElement(_MuiTableHead.default, tHead[0]), /*#__PURE__*/_react.default.createElement(_MuiTableBody.default, tBody[0]));
};

var _default = MuiTable;
exports.default = _default;
MuiTable.propTypes = {
  /**
   * stroyblok multiselect of css classes
   * Mui Override or extend the styles applied to the component.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui props: 'default', 'checkbox', 'none'
   * Allows TableCells to inherit padding of the Table.
   */
  padding: function padding(props, propName, componentName) {
    var validProps = ['default', 'checkbox', 'none'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * mui props: 'small', 'medium'
   * Allows TableCells to inherit size of the Table.
   */
  size: function size(props, propName, componentName) {
    var validProps = ['small', 'medium'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * mui props: true | false
   * set the header sticky. (It doesn't work with IE 11)
   */
  stickyHeader: _propTypes.default.bool,

  /**  MuiTableHead limit of 1 */
  tHead: function tHead(props, propName, componentName) {
    return (0, _customProps.validComponentsRequired)(props, propName, componentName, ['MuiTableHead'], 1);
  },

  /**  MuiTableBody limit of 1 */
  tBody: function tBody(props, propName, componentName) {
    return (0, _customProps.validComponentsRequired)(props, propName, componentName, ['MuiTableBody'], 1);
  }
};
MuiTable.defaultProps = {
  padding: 'default',
  size: 'medium',
  stickyHeader: false,
  rootClass: [],
  tHead: [],
  tBody: []
};